import { Switch } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMilesPoints } from "../../hooks/useMilesPoints";

function Toggle({ callback, value }) {
  const { toggleReward, toggleBadge, toggleMission } = useMilesPoints();
  const [toggle, setToggle] = useState(value?.isActive || false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (value?.isActive !== toggle) {
      setToggle(value?.isActive);
    }
  }, [value]);

  const handleChange = async () => {
    setToggle(!toggle);
    if (value?.dataType === "reward")
      return toggleReward({
        setLoading,
        id: value?._id,
        callback: callback?.({ ...value, isActive: !value?.isActive }),
      });
    if (value?.dataType === "badge")
      return toggleBadge({
        setLoading,
        id: value?._id,
        callback: callback?.({ ...value, isActive: !value?.isActive }),
      });
    if (value?.dataType === "mission")
      return toggleMission({
        setLoading,
        id: value?._id,
        callback: callback?.({ ...value, isActive: !value?.isActive }),
      });
  };

  return (
    <div>
      {loading ? (
        <div className="mt-2 ml-4">
          <div className="primaryLoader"></div>
        </div>
      ) : (
        <Switch checked={toggle} onChange={() => handleChange()} />
      )}
    </div>
  );
}

export default Toggle;
